import React from "react";
import { RichEmptyState } from "@jsq/ds/core";
import { emptyState, wrapper } from "./styles_vanilla.css";

export const ReportingMissingPermissionState: React.FC = () => {
  return (
    <div className={wrapper} data-testid="reporting-missing-permission-state">
      <RichEmptyState
        className={emptyState}
        description="You do not have the required permissions to access this page."
        illustration="searching"
        title="Access Denied"
      />
    </div>
  );
};
